export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/19ccbde051f49e3d.jpg"